export default __webpack_public_path__ + "static/media/user.374505c5.svg";